import { render } from "./Cotizaciones_DetailsView.vue?vue&type=template&id=48a29e3a"
import script from "./Cotizaciones_DetailsView.vue?vue&type=script&lang=js"
export * from "./Cotizaciones_DetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__